export const SocketEvents = {
    question: "question",
    chat: "chat",
    reaction: "reaction",
    error: "error",
    approveQuestion: "approveQuestion",
    liveStarted: "live_started",
    liveEnded: "live_ended",
    pong: "pong",
    deleteQuestion: "deleteQuestion",
    editQuestion: "editQuestion",
    likeQuestion: "likeQuestion",
    manageQuestion: "manageQuestion",
    broadcastQuestion: "broadcastQuestion",
    liveStream:"live_stream",
    liveIndexing:"event_indexing",
    trackEventDelay:"event_delay"
}